// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/login_bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  height: 100%;
}

body {
  font-family: 'Rubik', sans-serif;
}

.login-page {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: cover;
}

/* header a:hover img {
  background: url("../images/google-play-hover.svg") no-repeat;
} */

.sidebar::-webkit-scrollbar-track,
.sidebar nav::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.sidebar::-webkit-scrollbar,
.sidebar nav::-webkit-scrollbar {
  width: 6px;
}

.sidebar::-webkit-scrollbar-thumb,
.sidebar nav::-webkit-scrollbar-thumb {
  background-color: #63c3eb;
}

.sidebar nav a.active {
  background-color: #fff;
  color: #3e54ac;
}

.sidebar nav a.active img,
.sidebar nav a:hover img,
.sidebar nav button:hover img {
  /* filter: brightness(0) saturate(100%) invert(26%) sepia(62%) saturate(6496%) hue-rotate(248deg) brightness(98%) contrast(110%); */
  filter: invert(34%) sepia(9%) saturate(4869%) hue-rotate(195deg)
    brightness(64%) contrast(95%);
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: #000;
  -webkit-box-shadow: 0 0 0px 1000px #fff inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

.not-found {
  display: flex;
  text-align: center;
  justify-content: center;
}

.react-date-picker {
  padding: 0;
}

.react-date-picker .react-date-picker__wrapper {
  border-color: #c7bfbf;
  padding: 5px 8px;
  border-radius: 7px;
  color: #c7bfbf;
}

.react-date-picker__inputGroup__input:invalid {
  background: transparent !important;
}

.react-date-picker__button svg {
  opacity: 0.3;
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loading-spinner {
  width: 20px;
  height: 20px;
  border: 8px solid #09fd4a;
  border-top: 10px solid #383636;
  border-radius: 50%;
  animation: spinner 1.5s linear infinite;
  margin: 0 auto;
}
button:disabled {
  background-color: rgb(59 130 246 / 0.5);
}

/* .password_view {
  position: absolute;
  top: 40%;
  right: 20px;
  transform: translateY(-50%);
  font-size: 20px;
} */

/* .flatpickr {
  padding-right: 30px;
  background: url(../images/calender.png) no-repeat center right;
  background-color: transparent;
}

.flatpickr::after {
  content: "";
  display: block;
  position: absolute;
  background-color: transparent;
  top: 50%;
  right: 10px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 4px 0 4px;
  border-color: #333333 transparent transparent transparent;
  transform: translateY(-50%);
} */

.react-quill.custom-editor-height {
  height: 300px; /* Adjust the height as per your requirement */
}
.hideSideBar {
  display: none;
}

button:disabled:hover {
  background-color: rgb(59 130 246 / 0.5);
}

.tableFixHead {
  overflow: auto;
  max-height: 440px;
}
.tableFixHead thead th {
  position: sticky;
  top: 0; /* z-index: 1; */
  background: #e1e6ee;
}

/* CSS for View Form of Form Management */
.form-view h2 {
  font-size: 1rem; /* Typical h2 size, adjust as needed */
  font-weight: bold; /* If strong isn't enough */
  margin: 1em 0; /* Add proper heading spacing */
}
.form-view h3 {
  font-size: 0.5rem; /* Typical h2 size, adjust as needed */
  font-weight: bold; /* If strong isn't enough */
  margin: 1em 0; /* Add proper heading spacing */
}

.form-view-text-editor p{
  font-size: 14px;
}

h2.ql-align-center {
    font-size: 16px;
}

.inner-html > ol,
.inner-html > ul,
.inner-html > menu {
  list-style: revert;
  margin: 0;
  padding-left: 15px;
}

.inner-html li > ul {
  padding-left: 10px; /* adjust as needed */
    list-style: revert;
}
.css-hlgwow {
  max-width: 100%;
}
.select__value-container {
    flex-wrap: nowrap !important;
    overflow-x: auto !important;
    max-width: 100%;
}
.shadow-long {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 1px 1px 2px 1px #6f6f6f !important;
}
.font-semiboldone {
  margin: auto !important;
}
.background-input {
  padding-bottom: 8px !important;
  padding-top: 8px !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oEAAiD;EACjD,sBAAsB;AACxB;;AAEA;;GAEG;;AAEH;;EAGE,4CAA4C;AAC9C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;;EAGE,mIAAmI;EACnI;iCAC+B;AACjC;;AAEA;;;;;;;;;EASE,6BAA6B;EAC7B,6CAA6C;EAC7C,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;AAChB;AACA;EACE,uCAAuC;AACzC;;AAEA;;;;;;GAMG;;AAEH;;;;;;;;;;;;;;;;;;;GAmBG;;AAEH;EACE,aAAa,EAAE,8CAA8C;AAC/D;AACA;EACE,aAAa;AACf;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,MAAM,EAAE,gBAAgB;EACxB,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,eAAe,EAAE,sCAAsC;EACvD,iBAAiB,EAAE,2BAA2B;EAC9C,aAAa,EAAE,+BAA+B;AAChD;AACA;EACE,iBAAiB,EAAE,sCAAsC;EACzD,iBAAiB,EAAE,2BAA2B;EAC9C,aAAa,EAAE,+BAA+B;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;EAGE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB,EAAE,qBAAqB;IACvC,kBAAkB;AACtB;AACA;EACE,eAAe;AACjB;AACA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,eAAe;AACnB;AACA;EACE,+EAA+E;EAC/E,mGAAmG;EACnG,8CAA8C;AAChD;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700;800&display=swap');\n\nhtml,\nbody,\n#root {\n  height: 100%;\n}\n\nbody {\n  font-family: 'Rubik', sans-serif;\n}\n\n.login-page {\n  background: url('/login_bg.jpg') no-repeat center;\n  background-size: cover;\n}\n\n/* header a:hover img {\n  background: url(\"../images/google-play-hover.svg\") no-repeat;\n} */\n\n.sidebar::-webkit-scrollbar-track,\n.sidebar nav::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n\n.sidebar::-webkit-scrollbar,\n.sidebar nav::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar::-webkit-scrollbar-thumb,\n.sidebar nav::-webkit-scrollbar-thumb {\n  background-color: #63c3eb;\n}\n\n.sidebar nav a.active {\n  background-color: #fff;\n  color: #3e54ac;\n}\n\n.sidebar nav a.active img,\n.sidebar nav a:hover img,\n.sidebar nav button:hover img {\n  /* filter: brightness(0) saturate(100%) invert(26%) sepia(62%) saturate(6496%) hue-rotate(248deg) brightness(98%) contrast(110%); */\n  filter: invert(34%) sepia(9%) saturate(4869%) hue-rotate(195deg)\n    brightness(64%) contrast(95%);\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n  -webkit-text-fill-color: #000;\n  -webkit-box-shadow: 0 0 0px 1000px #fff inset;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n.not-found {\n  display: flex;\n  text-align: center;\n  justify-content: center;\n}\n\n.react-date-picker {\n  padding: 0;\n}\n\n.react-date-picker .react-date-picker__wrapper {\n  border-color: #c7bfbf;\n  padding: 5px 8px;\n  border-radius: 7px;\n  color: #c7bfbf;\n}\n\n.react-date-picker__inputGroup__input:invalid {\n  background: transparent !important;\n}\n\n.react-date-picker__button svg {\n  opacity: 0.3;\n}\n\n@keyframes spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.loading-spinner {\n  width: 20px;\n  height: 20px;\n  border: 8px solid #09fd4a;\n  border-top: 10px solid #383636;\n  border-radius: 50%;\n  animation: spinner 1.5s linear infinite;\n  margin: 0 auto;\n}\nbutton:disabled {\n  background-color: rgb(59 130 246 / 0.5);\n}\n\n/* .password_view {\n  position: absolute;\n  top: 40%;\n  right: 20px;\n  transform: translateY(-50%);\n  font-size: 20px;\n} */\n\n/* .flatpickr {\n  padding-right: 30px;\n  background: url(../images/calender.png) no-repeat center right;\n  background-color: transparent;\n}\n\n.flatpickr::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  background-color: transparent;\n  top: 50%;\n  right: 10px;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 6px 4px 0 4px;\n  border-color: #333333 transparent transparent transparent;\n  transform: translateY(-50%);\n} */\n\n.react-quill.custom-editor-height {\n  height: 300px; /* Adjust the height as per your requirement */\n}\n.hideSideBar {\n  display: none;\n}\n\nbutton:disabled:hover {\n  background-color: rgb(59 130 246 / 0.5);\n}\n\n.tableFixHead {\n  overflow: auto;\n  max-height: 440px;\n}\n.tableFixHead thead th {\n  position: sticky;\n  top: 0; /* z-index: 1; */\n  background: #e1e6ee;\n}\n\n/* CSS for View Form of Form Management */\n.form-view h2 {\n  font-size: 1rem; /* Typical h2 size, adjust as needed */\n  font-weight: bold; /* If strong isn't enough */\n  margin: 1em 0; /* Add proper heading spacing */\n}\n.form-view h3 {\n  font-size: 0.5rem; /* Typical h2 size, adjust as needed */\n  font-weight: bold; /* If strong isn't enough */\n  margin: 1em 0; /* Add proper heading spacing */\n}\n\n.form-view-text-editor p{\n  font-size: 14px;\n}\n\nh2.ql-align-center {\n    font-size: 16px;\n}\n\n.inner-html > ol,\n.inner-html > ul,\n.inner-html > menu {\n  list-style: revert;\n  margin: 0;\n  padding-left: 15px;\n}\n\n.inner-html li > ul {\n  padding-left: 10px; /* adjust as needed */\n    list-style: revert;\n}\n.css-hlgwow {\n  max-width: 100%;\n}\n.select__value-container {\n    flex-wrap: nowrap !important;\n    overflow-x: auto !important;\n    max-width: 100%;\n}\n.shadow-long {\n  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);\n  box-shadow: 1px 1px 2px 1px #6f6f6f !important;\n}\n.font-semiboldone {\n  margin: auto !important;\n}\n.background-input {\n  padding-bottom: 8px !important;\n  padding-top: 8px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
